import { render, staticRenderFns } from "./PayrollSelect.vue?vue&type=template&id=8425af64"
import script from "./PayrollSelect.vue?vue&type=script&lang=ts"
export * from "./PayrollSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports